<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="10" xs="10" sm="8" md="8" lg="8" class="vertical-no-padding-col">
        <TitleLabel :title="title" />
      </v-col>
    </v-row>
    <v-row justify="center" class="other-team">
      <v-col cols="12" xs="12" sm="5" md="5" lg="5" v-for="n in teamIdArray.length" :key="n">
        <OtherTeamTank
          :tank-name="teamNameArray[n - 1]"
          :image-url="tankImageArray[n - 1]"
          @clickAction="toSomeTeam(teamIdArray[n - 1])"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleLabel from '../Atoms/TitleLabel'
import OtherTeamTank from '../Organisms/OtherTeamTank'
import errorHandle from "../../util/errorHandle.js";

export default {
  name: "OtherTeam",
  data: () => ({
    title:"見たいチームを選んでください。",
    teamIds: [],
    accessToken: "",
    userAuthority: "",
    teamIdArray:[],
    teamNameArray: [],
    tankIdArray: [],
    tankImageArray:[]
  }),
  created() {
    this.fetchInitialData()
    this.getTeams().then(() => {
      this.getTank()
    })
  },
  mounted() {
    this.initIcon()

  },
  methods: {
    fetchInitialData() {
      const user_info = this.$store.getters["user/getUserInfo"];
      this.teamIds = user_info.teamIds
      this.accessToken = user_info.accessToken;
      this.userAuthority = user_info.userAuthority;
    },
    initIcon() {
      this.$emit('initIcon')
    },
    getTeams() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .get(`/api/teams`, header)
          .then(response => {
            let teams = response.data.teams
            for (let team of teams) {
              this.teamIdArray.push(team.id)
              this.teamNameArray.push(team.name)
              this.tankIdArray.push(team.tank_id)
            }
            resolve();
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.fetchInitialData();
                this.getTeams();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });
    },
    getTank() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .get("/api/tanks", header)
          .then(response => {
            let tanks = response.data.tanks
            for (let tankId of this.tankIdArray) {
              for (let tank of tanks) {
                if (tank.id === tankId) {
                  this.tankImageArray.push(tank.image.url)
                }
              }
            }
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.fetchInitialData();
                this.getTank();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });

    },
    toSomeTeam(teamId) {
      this.$store.commit("team/SET_TEAM_INFO", teamId);
      if (this.teamIds[0] === teamId || this.userAuthority === "MANAGER") {
        this.$router.push({ name: 'Top'}).catch(() => {});
      } else {
        this.$router.push({ name: 'OtherTeamTop' }).catch(() => {});
      }
    }
  },
  components: {
    TitleLabel,
    OtherTeamTank
  },
  head: {
    title: {
      inner: 'other-team',
    }
  }
};
</script>

<style scoped>
.other-team {
  min-height: 50vh;
}
</style>
